import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';

import {
  Box,
  Button,
  Divider,
  Modal,
  TextField,
  Typography
} from '@mui/material';

import LoadingButton from '../../../../../components/buttons/Button';

import {
  CreateUsitcRevisionBIZcoreTD,
  UpdateUsitcRevisionBIZcoreTD
} from '../../../../../redux/actions/business/core/tradeDefencesActions';

import global from "../../../../../global.scss";

const MODES = { CREATE: 1, EDIT: 2 };

const Data = {
  RevisionName: "",
  EffectiveDate: "",
  ExpirationDate: "",
};

const UsitcRevisionsModal = ({
  open,
  setOpen,
  title,
  update,
  handleGet
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(Data);
  const [mode, setMode] = useState(MODES.CREATE);

  const handleClose = () => {
    setOpen(false);
    setFormData(Data);
    setMode(MODES.CREATE);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    try {
      if (open) {
        if (update.defaultMode === MODES.CREATE) {
          setMode(MODES.CREATE);
        } else if (update.defaultMode === MODES.EDIT) {
          setMode(MODES.EDIT);
          setFormData({
            RevisionName: update.revision_name || "",
            EffectiveDate: update.effective_date || "",
            ExpirationDate: update.expiration_date || "",
          });
        } else {
          toast.error("Invalid modal");
          handleClose();
        }
      }
    } catch (err) {
      console.log(err);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleSubmit = () => {
    const obj = {
      revision_name: formData.RevisionName,
      effective_date: formData.EffectiveDate,
      expiration_date: formData.ExpirationDate || null,
    };

    if (mode === MODES.CREATE) {
      dispatch(CreateUsitcRevisionBIZcoreTD(obj, setLoading)).then(() => {
        handleGet(setLoading).then(() => {
          handleClose();
        });
      });
    } else if (mode === MODES.EDIT) {
      dispatch(UpdateUsitcRevisionBIZcoreTD(update.id, obj, setLoading)).then(() => {
        handleGet(setLoading).then(() => {
          handleClose();
        });
      });
    } else {
      toast.error("Invalid modal");
      handleClose();
    }
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
    >
      <Box className="flexCenterCenterRow" width={"100vw"} height={"100vh"}>
        <Box maxWidth={"sm"} className="modal">
          <Box width={"100%"} sx={{ padding: "15px" }}>
            <Typography variant='h6'
              sx={{ color: global["primary"] }} mb={"20px"}>
              {title}
            </Typography>

            {/* Revision Name */}
            <Box mb={"15px"}>
              <TextField
                label="Revision name"
                fullWidth
                name="RevisionName"
                value={formData.RevisionName}
                onChange={handleChange}
                inputProps={{ maxLength: 100 }}
              />
            </Box>

            {/* Effective Date + Expiration Date */}
            <Box className="flexCenterSBRow" gap={"15px"} mb={"15px"}>
              <TextField
                label="Effective date"
                fullWidth
                name="EffectiveDate"
                type="date"
                value={formData.EffectiveDate}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              />
              <TextField
                label="Expiration date (optional)"
                fullWidth
                name="ExpirationDate"
                type="date"
                value={formData.ExpirationDate}
                onChange={handleChange}
                InputLabelProps={{ shrink: true }}
              />
            </Box>
          </Box>

          <Divider sx={{ backgroundColor: "rgba(44, 45, 47, 1)" }} />
          <Box className="flexCenterFERow" sx={{ gap: "20px", margin: "15px" }}>
            <Button variant='text' onClick={handleClose}>
              Cancel
            </Button>
            <LoadingButton
              variant='contained'
              loading={loading}
              disabled={formData.RevisionName === "" || formData.EffectiveDate === ""}
              onClick={handleSubmit}
            >
              Submit
            </LoadingButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default UsitcRevisionsModal;
